/*!

=========================================================
* Now UI Dashboard React - v1.4.0
=========================================================

* Product Page: https://www.creative-tim.com/product/now-ui-dashboard-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/now-ui-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
// javascript plugin used to create scrollbars on windows
import PerfectScrollbar from "perfect-scrollbar";

// reactstrap components
import { Route, Switch, Redirect,useParams } from "react-router-dom";

// core components
import DemoNavbar from "components/Navbars/Navbar.js";
import Footer from "components/Footer/Footer.js";
import Sidebar from "components/Sidebar/Sidebar.js";
import { Alert } from "components/Varios/Alert.js";
import DatosGenerales from 'components/DatosGenerales';

import { history } from '../helpers/history';
import { Role } from '../helpers/role';
import { authenticationService } from '../services/authentication.service';
import { PrivateRoute } from '../components/Varios/PrivateRoute';

import routes from "routes.js";

//Barras de navegacion
import MetisMenu from 'react-metismenu';
//Componentes para inicio sin login
import Dashboards_Inicio from "components/NoLogin/Dashboard_Inicio";
import Banner_Inicio from "components/NoLogin/Banner_Inicio";
import Formularios from "components/NoLogin/Formularios";
import NavTemporal from "components/NoLogin/NavTemporal";
import Files from "components/NoLogin/Files";


class NoLoginLayout extends React.Component {
    state = {
        currentUser: null,
      
    };

    componentDidMount() {      
        // authenticationService.currentUser.subscribe(x => this.setState({
        //     currentUser: x
        // }));
    }
    

    logout() {
       // authenticationService.logout();
    }

    render() {
        return this.renderPage();
    }

    renderPage() {
        
        if(authenticationService.currentUserValue !== null && authenticationService.currentUserValue.token !== ""){
            return <Redirect to={"/web"}  />
        }
        return (
            
            <React.Fragment>
                <DemoNavbar {...this.props} />
                <NavTemporal/>
                <Switch>
                    <Route exact path ="/">
                        <Banner_Inicio/>
                    </Route>
                    <Route exact path ="/formularios">
                        <Formularios/>
                    </Route>
                    <Route  exact path ="/downloadfiles/:nombre">
                        <Files/>
                    </Route>
                    
                </Switch>
                <Footer fluid />

            </React.Fragment>
        );
    }
}

export default NoLoginLayout;
